export const A11yRequired = (el, binding) => {
    el.required = binding.value
}
